module.exports = __webpack_public_path__ + "static/img/SFU老师_Stacy.c247d97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/SFU/SFU老师_Stacy.png
// module id = Z+L0
// module chunks = 0